import React, { memo } from 'react';
import { Card } from '@mui/material';
import './styles.scss';

export interface ICardComponentProps {
  children: React.ReactNode;
  customStyles?: any;
  id?: string;
}

const CardComponent = ({
  id,
  children,
}: ICardComponentProps) => {
  return (
    <Card
      className="card"
      id={id}
    >
      {children}
    </Card>
  );
};

export default memo(CardComponent);
